export default __webpack_public_path__ + "media/images/pumpkins-nights-fun-card-title-3718f150e11c8c2f2e760bd788a236f4.svg";